module.exports = __webpack_public_path__ + "img/8cda575.png";